import React from 'react';

/**
 * GroupViewTabs - Toggle between "My Groups" and "Invited" views
 * Consistent with Dashboard, Polls, and Watchlists tabs
 */
const GroupViewTabs = ({ 
  groupView, 
  setGroupView, 
  myGroupsCount, 
  invitedCount 
}) => {
  return (
    <div className="flex items-center bg-black/20 rounded-lg p-1">
      <button
        onClick={() => setGroupView('my')}
        data-testid="my-groups-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          groupView === 'my' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        My Groups
        {myGroupsCount > 0 && (
          <span className={`ml-1.5 text-xs ${groupView === 'my' ? 'text-slate-500' : 'text-white/50'}`}>
            ({myGroupsCount})
          </span>
        )}
      </button>
      <button
        onClick={() => setGroupView('invited')}
        data-testid="invited-groups-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          groupView === 'invited' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Invited
        {invitedCount > 0 && (
          <span className={`ml-1.5 text-xs ${groupView === 'invited' ? 'text-slate-500' : 'text-white/50'}`}>
            ({invitedCount})
          </span>
        )}
      </button>
    </div>
  );
};

export default GroupViewTabs;
